import { FC } from 'react';
import { IToolEvidence } from '../../toolEvidenceCarousel.types';
import './ToolEvidenceCarouselItem.scss';

/**
 * Componente que muestra una imagen individual del carrusel de evidencias
 * @param evidence - Datos de la evidencia fotográfica
 * @param onClick - Función que se ejecuta al hacer click en la imagen
 */
const ToolEvidenceCarouselItem: FC<ToolEvidenceCarouselItemProps> = ({ evidence, onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick(evidence);
    }
  };

  return (
    <figure className="toolEvidenceCarouselItem" onClick={handleClick}>
      <img src={evidence?.imageUrl} alt={`Evidencia ${evidence?.id}`} className="evidenceImage" />
    </figure>
  );
};

interface ToolEvidenceCarouselItemProps {
  evidence: IToolEvidence;
  onClick?: (evidence: IToolEvidence) => void;
}

export default ToolEvidenceCarouselItem;
